import React, { useEffect, useState } from 'react';
import Selection from '../../../selection';

function IVA2(props) {
    const [display, setDisplay] = useState(displayPage())

    useEffect(() => {
        setDisplay(displayPage())
    }, [props.page, props.store])

    function displayPage() {
        switch (props.page) {
            case 100:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "Has " + props.store.first_name_2 + " ever had an Individual Voluntary Arrangement (IVA)?",
                        info: {
                            id: "iva_modal_2",
                            text: "What is an individual voluntary agreement?",
                            content: "An IVA (or Individual Voluntary Arrangement) is a legally binding agreement between you and your creditors (people who you owe money to). It’s so you can repay your debts over an agreed time period, usually between 5 and 6 years.",
                            content2: "When lenders see an IVA on your credit file, they perceive you to be ‘high-risk’ because you’ve faced difficulties in repaying debts in the past. But it doesn’t mean you won’t be able to borrow any money."
                        },
                        buttons: {
                            "Yes": {
                                value: "YES",
                                next: 101
                            },
                            "No": {
                                value: "NO",
                                next: 102
                            }
                        }
                    }} id={"had_a_iva_2"} setValue={(e) => props.setValue({ ...props.store, had_a_iva_2: e })} />
                )
            
            case 101:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "When was " + props.store.first_name_2 + " discharged?",
                        input: {
                            type: "month",
                            id: "iva_discharged_2",
                            min: 7,
                            next: 102
                        },
                        sub_button: {
                            "Or mark this IVA as not yet satisfied": {
                                value: "ONGOING",
                                next: 102
                            }
                        }
                    }} id={"iva_discharged_2"} setValue={(e) => props.setValue({ ...props.store, iva_discharged_2: e })} />
                )
        }
    }

    return (
        <div>
            {display}
        </div>
    );
}

export default IVA2;